<template>
  <div class="page-content role">
    <h1 class="page-title">{{ $locale("sideMenu.users.roleManagement") }}</h1>

    <!-- Search Area -->
    <el-row class="search-area">
      <el-col :span="20">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input :placeholder="$locale('role.plsEnterRoleName')" v-model="filter.name">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="6">
            <el-select :placeholder="$locale('global.permission')" v-model="filter.permissions">
              <el-option
                v-for="status in permissionOptions"
                :key="status.label"
                :value="status.value"
                :label="status.label"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select :placeholder="$locale('global.state')" v-model="filter.status">
              <el-option
                v-for="status in statusOptions"
                :key="status.label"
                :value="status.value"
                :label="status.label"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" class="ta-r">
        <el-button class="egl-btn-yellow right-align-btn" @click="toDetail('create')">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="roleTable" class="egl-table" :border="true">
      <el-table-column min-width="120" align="center">
        <template slot="header">{{ $locale('role.name') }}</template>
        <template slot-scope="scope"><h3 :title="scope.row.name">{{ scope.row.name }}</h3></template>
      </el-table-column>
      <el-table-column min-width="800">
        <template slot="header">{{ $locale('global.permission') + '（' + $locale("role.permission") + '）' }}</template>
        <template slot-scope="scope">
          <el-table :data="scope.row.permissionConfs" :show-header="false" :border="false" stripe>
            <el-table-column prop="permission" width="240">
              <template slot-scope="scope"><strong :title="scope.row.permission">{{ scope.row.permission }}</strong></template>
            </el-table-column>
            <el-table-column prop="types">
              <template slot-scope="scope">
                <p
                  v-for="(text, index) in scope.row.types"
                  :key="index"
                  class="role-tags"
                  :title="text"
                >
              <span>{{ text }}</span>
              <el-divider direction="vertical" v-if="index < scope.row.types.length -1"></el-divider>
              </p>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="role-permission">
            <template v-for="permission in scope.row.permissionConfs">
              <p v-if="permission.permission != 'empty'" :key="permission.permission">
                {{ permission.permission }}：
                <el-tag
                  v-for="(text, index) in permission.types"
                  :key="permission.permission + index"
                  type="warning"
                  :title="text"
                >{{ text }}</el-tag>
              </p>
            </template>
          </div> -->
        </template>
      </el-table-column>
      <el-table-column width="100" align="center">
        <template slot="header">{{ $locale("global.control") }}</template>
        <template slot-scope="scope">
          <div class="handle">
            <a @click="toDetail('detail', scope.row.id)">{{ $locale("global.detail") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="toDetail('edit', scope.row.id)">{{ $locale("global.edit") }}</a>
            <template v-if="!isAdmin && adminType != 'superAdmin'">
              <el-divider direction="vertical"></el-divider>
              <a @click="deleteRole_fn(scope.$index)">{{ $locale("global.delete") }}</a>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>

<script>
import { getRoleList } from "@/helpers/service/api/common.js";
import { deleteRole } from "@/helpers/service/api/role.js";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import "@/assets/style/role.less";

export default {
  name: "role",
  components: {
    CommPagination,
  },
  data() {
    return {
      onSearch: {
        name: "",
        permissions: "",
        status: "",
        page: 0,
        pageSize: 10,
      },
      filter: {
        name: "",
        permissions: "",
        status: "",
      },
      pageCount: 0,
      roleTable: [],
      permissionOptions: [],
      statusOptions: [
        {
          label: this.$locale("global.active"),
          vlaue: "active",
        },
        {
          label: this.$locale("global.inactive"),
          value: "inactive",
        }
      ],
      isAdmin: false,
      adminType: "",
    };
  },
  methods: {
    getRoleList_fn() {
      let obj = { ...this.onSearch };

      getRoleList(obj).then(res => {
        if (res.success) {
          this.roleTable = [ ...res.data.data ];
          // this.pageCount = Math.ceil(res.data.count / 10);
          this.pageCount = res.data.count || 0;
        }
      }).catch(() => {});
    },
    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1,
      };

      this.search_fn();
    },
    search_fn() {
      this.onSearch = {
        ...this.onSearch,
        ...this.filter,
      };

      this.getRoleList_fn();
    },
    toDetail(act = "create", id = "") {
      let path = "";

      path = "/role/" + act;

      if (id != "") {
        path = path + "/" + id;
      }

      this.$router.push({ path: path });
    },
    deleteRole_fn(index) {
      const that = this;
      const roleName = that.roleTable[index].name;
      const roleId = that.roleTable[index].id;
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${roleName}</span>`;

      that.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: that.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: that.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        // confirm
        deleteRole({ id: roleId }).then(res => {
          if (res.success) {
            countDownAlert({
              content: that.$locale("global.deleteSuccessfully"),
              callback: () => {
                that.search_fn();
              }
            });
          }
        });
      });
    },
  },
  mounted() {
    this.isAdmin = window.localStorage.getItem("isAdmin") || false;
    this.adminType = window.localStorage.getItem("adminType");
    this.getRoleList_fn();
  },
};
</script>
